import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

import button from "../../../assets/img/landingPageFive/sectionSeven/button.webp";

function SectionSeven() {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={100}>
      <div id="map" className={`sectionSeven-bg ${isVisible ? "visible" : ""}`}>
        <div className="sectionSeven">
          <div className="text">
            <h1 className={`${isVisible ? "visible" : ""}`}>
              {t("lp5_cta_title")}
            </h1>
            <p className={`${isVisible ? "visible" : ""}`}>
              {t("lp5_cta_text")}
            </p>
          </div>
          <div className={`line ${isVisible ? "visible" : ""}`}></div>
          <a
            className={`${isVisible ? "visible" : ""}`}
            href={"#home"}
            rel="noreferrer"
            reloadDocument
          >
            <img src={button} alt="" />
            <p>{t("lp5_cta_experts")}</p>
          </a>
        </div>
      </div>
    </VisibilitySensor>
  );
}

export default SectionSeven;
